import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import { arraysEqual } from '../utils';

import './CategoryFilter.scss';

class CategoryFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCategories: [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.loading && this.props.loading) {
      this.props.closeFilter('category');
    }

    // Update state with already applied filters
    if (
      nextProps.open !== this.props.open &&
      nextProps.appliedCategories &&
      nextProps.appliedCategories !== this.state.selectedCategories
    ) {
      this.setState({ selectedCategories: nextProps.appliedCategories });
    }
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (
      this.props.mobile &&
      !arraysEqual(this.state.selectedCategories, nextState.selectedCategories)
    ) {
      this.props.updateMobileFilters('category', nextState.selectedCategories);
    }
  }

  updateSelectedWithApplied = () => {
    if (this.props.appliedCategories) {
      this.setState({ selectedCategories: this.props.appliedCategories });
    }
  };

  filterButtonClicked = () => {
    if (this.props.open) {
      this.props.closeFilter('category');
    } else {
      this.props.openFilter('category');
    }
  };

  handleClickOutside = (evt) => {
    if (this.props.open && !this.props.loading && !this.props.mobile) {
      this.props.closeFilter('category');
      this.clearFilter();
    }
  };

  applyCategoryFilters = () => {
    if (this.state.selectedCategories.length === 0) {
      this.props.applyFilter('category', []);
    }

    this.props.applyFilter('category', this.state.selectedCategories);
  };

  // Clears all unapplied categories from UI
  clearFilter = () => {
    this.setState({ selectedCategories: [] });
  };

  // Clears and applies reset
  clearAndApply = () => {
    this.clearFilter();
    this.props.applyFilter('category', []);
  };

  toggleSwitch = (category) => {
    if (this.isCategorySelected(category)) {
      this.deselectCategory(category);
    } else {
      this.selectCategory(category);
    }
  };

  // Returns whether a category has been selected
  isCategorySelected = (category) => {
    return this.state.selectedCategories.indexOf(category) >= 0;
  };

  // Select a category
  selectCategory = (category) => {
    const selectedCategories = this.state.selectedCategories.slice();
    const index = selectedCategories.indexOf(category);

    if (index < 0) {
      selectedCategories.push(category);
      this.setState({ selectedCategories });
    }
  };

  // Deselect a category
  deselectCategory = (category) => {
    const selectedCategories = this.state.selectedCategories.slice();
    const index = selectedCategories.indexOf(category);

    if (index >= 0) {
      selectedCategories.splice(index, 1);
      this.setState({ selectedCategories });
    }
  };

  filterLabel = () => {
    let labelCategories = null;

    if (this.props.open) {
      labelCategories = this.state.selectedCategories;
    } else {
      labelCategories = this.props.appliedCategories;
    }

    if (!labelCategories || labelCategories.length === 0) {
      return 'Category';
    }
    if (labelCategories.length === 1) {
      return labelCategories[0];
    }
    return `Category (${labelCategories.length})`;
  };

  renderCategories = () => {
    const splicedCategories = this.props.categories.slice(0, 10);

    const groupedCategories = [];
    while (splicedCategories.length > 0)
      groupedCategories.push(splicedCategories.splice(0, 5));

    return groupedCategories.map((categories) => {
      const column = categories.map((category) => (
        <div
          key={category}
          className="categoryOption"
          onClick={() => this.toggleSwitch(category)}
        >
          <div className="name">{category}</div>
          <div
            className={`toggle ${
              this.isCategorySelected(category)
                ? 'selected brand-bg'
                : 'default'
            }`}
          >
            <i className="icon af-checkmark" />
          </div>
        </div>
      ));

      return (
        <div key={categories[0]} className="listColumn">
          {column}
        </div>
      );
    });
  };

  renderClearButton = () => {
    if (this.state.selectedCategories.length > 0) {
      return (
        <div className="clearButton brand-color" onClick={this.clearAndApply}>
          Clear
        </div>
      );
    }
    return <div />;
  };

  renderMobile = () => {
    const categories = this.props.categories.slice(0, 10);
    const catList = categories.map((category, index) => (
      <div
        key={category}
        className={`categoryOption ${
          categories.length === index + 1 ? 'last' : ''
        }`}
        onClick={() => this.toggleSwitch(category)}
      >
        <div className="name">{category}</div>
        <div
          className={`toggle ${
            this.isCategorySelected(category) ? 'selected brand-bg' : 'default'
          }`}
        >
          <i className="icon af-checkmark" />
        </div>
      </div>
    ));

    return (
      <div className="filterBody categoryFilter mobile">
        <div className="heading">Category</div>
        <div className="categoryList">{catList}</div>
      </div>
    );
  };

  render() {
    if (!this.props.enabled) return null;
    if (this.props.mobile) return this.renderMobile();

    return (
      <div className="filter">
        <div
          className={`filterButton brand-border
            ${this.props.open ? 'open brand-bg' : null}
            ${this.props.filterApplied ? 'filterApplied brand-bg' : null}`}
          onClick={this.filterButtonClicked}
        >
          {this.filterLabel()}
        </div>

        <div
          className={`filterPopover categoryFilterPopover arrow-top
          ${this.props.open ? '' : 'hidden'}
          ${this.props.categories.length > 5 ? 'expanded' : ''}
          `}
        >
          <div className="filterBody categoryFilter">
            <div className="categoryList">{this.renderCategories()}</div>
            <div className="filterActions">
              {this.renderClearButton()}
              <div
                className={`applyButton submitButton ui fluid button anygreen brand-bg
                ${this.props.loading ? 'loading' : null}
                `}
                onClick={this.applyCategoryFilters}
              >
                Apply
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default onClickOutside(CategoryFilter);
